<template>
  <content-loader
    class="tag-placeholder position-relative"
    primary-color="#ffffff"
    secondary-color="#cccccc"
    :primary-opacity="0.6"
    :secondary-opacity="0.5"
    :width="width"
    :height="height"
  >
    <rect x="0" y="0" rx="20" ry="20" :width="width" :height="height" />
  </content-loader>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { ContentLoader } from "vue-content-loader";

defineOptions({
  name: "tag-placeholder",
});

const minWidth = ref(window.innerWidth > 767 ? 90 : 65);
const maxWidth = ref(window.innerWidth > 767 ? 180 : 165);
const height = ref(window.innerWidth > 767 ? 40 : 34);
const width = ref(0);

const getWidth = () => {
  return Math.floor(Math.random() * (maxWidth.value - minWidth.value + 1) + minWidth.value);
};

onMounted(() => {
  width.value = getWidth();
});
</script>

<style lang="scss">
@import "./index";
</style>
